import React from 'react';
import { Button } from '@/components/ui/button';
import { Upload } from 'lucide-react';

interface FileUploadCardProps {
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  fileName: string;
}

export const FileUploadCard = ({ onFileChange, fileName }: FileUploadCardProps) => {
  return (
    <div className="flex-1 bg-muted rounded-lg p-4 border">
      <div className="flex items-center gap-2 mb-2">
        <Upload className="w-5 h-5 text-primary" />
        <span className="font-semibold">2. Sube tu Archivo</span>
      </div>
      <p className="text-sm text-muted-foreground mb-2">Selecciona el archivo Excel con los datos de los alumnos</p>
      <label className="block">
        <input type="file" accept=".xlsx,.xls" onChange={onFileChange} className="hidden" />
        <Button asChild variant="outline" className="w-full md:w-auto cursor-pointer">
          <span>
            <Upload className="w-4 h-4 mr-2" />
            Seleccionar archivo {fileName && <span className="ml-2 text-xs text-muted-foreground">{fileName}</span>}
          </span>
        </Button>
      </label>
    </div>
  );
};